import { TableColumn } from '@ui/aos-lib';
import { EquipmentListingFieldName } from '../../equipment/devices/components/devices.models';
import {
  SEARCH_HINTS,
  commodityTableIcon
} from '../../../shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { ReportGroupsEditModalColumnComponent } from './components/edit-modal-column/edit-modal-column.component';
import { ReportGroupNameColumnComponent } from './components/report-group-name-column/report-group-name-column.component';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { Applicable, GroupStatus } from './report-groups.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { IconColumnComponent } from 'src/app/shared/components/listing-table/components/icon-column.component';
import { TextTranslateColumnComponent } from 'src/app/shared/components/listing-table/components/text-translate-column.component';

export enum ReportGroupsFieldName {
  GroupName = 'GroupName',
  GroupStatus = 'GroupStatus',
  Commodity = 'Commodity',
  Applicable = 'Applicable',
  DeviceCount = 'DeviceCount',
  LastEdited = 'UpdatedOn',
  UpdatedBy = 'UpdatedBy'
}

export const SEARCH_TYPES = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALL,
    value: 1,
    types: [ReportGroupsFieldName.GroupName, ReportGroupsFieldName.UpdatedBy],
    hintText: SEARCH_HINTS.Search
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.REPORT_GROUP_NAME,
    value: 2,
    types: [ReportGroupsFieldName.GroupName],
    hintText: SEARCH_HINTS.ReportGroupName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.UPDATED_BY,
    value: 3,
    types: [ReportGroupsFieldName.UpdatedBy],
    hintText: SEARCH_HINTS.UpdatedBy
  }
];

export const statusFilterModel: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.STATUS,
  filterType: ReportGroupsFieldName.GroupStatus,
  selected: [
    { text: TranslateRegistry.get.FILTER.STATUS.ACTIVE, value: GroupStatus.Active },
    { text: TranslateRegistry.get.FILTER.STATUS.INACTIVE, value: GroupStatus.Inactive },
    { text: TranslateRegistry.get.FILTER.STATUS.CALCULATING, value: GroupStatus.Calculating }
  ],
  items: [
    { text: TranslateRegistry.get.FILTER.STATUS.ACTIVE, value: GroupStatus.Active },
    { text: TranslateRegistry.get.FILTER.STATUS.INACTIVE, value: GroupStatus.Inactive },
    { text: TranslateRegistry.get.FILTER.STATUS.CALCULATING, value: GroupStatus.Calculating }
  ],
  isMultiselect: true,
  width: 160
};

export const commodityFilterModel: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.COMMODITY,
  filterType: ReportGroupsFieldName.Commodity,
  selected: [
    { text: TranslateRegistry.get.FILTER.COMMODITY.GAS, value: 'Gas' },
    { text: TranslateRegistry.get.FILTER.COMMODITY.WATER, value: 'Water' },
    { text: TranslateRegistry.get.FILTER.COMMODITY.ELECTRIC, value: 'Electricity' }
  ],
  items: [
    { text: TranslateRegistry.get.FILTER.COMMODITY.GAS, value: 'Gas' },
    { text: TranslateRegistry.get.FILTER.COMMODITY.WATER, value: 'Water' },
    { text: TranslateRegistry.get.FILTER.COMMODITY.ELECTRIC, value: 'Electricity' }
  ],
  isMultiselect: true,
  width: 160
};

export const applicableFilterModel: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.APPLICABLE,
  filterType: ReportGroupsFieldName.Applicable,
  selected: [
    { text: Applicable.AmiHealthDashboard, value: Applicable.AmiHealthDashboard },
    { text: Applicable.ConsumptionAnalytics, value: Applicable.ConsumptionAnalytics },
    { text: Applicable.NetworkMonitoring, value: Applicable.NetworkMonitoring }
  ],
  items: [
    { text: Applicable.AmiHealthDashboard, value: Applicable.AmiHealthDashboard },
    { text: Applicable.ConsumptionAnalytics, value: Applicable.ConsumptionAnalytics },
    { text: Applicable.NetworkMonitoring, value: Applicable.NetworkMonitoring }
  ],
  isMultiselect: true,
  width: 180
};

export const tableConfig: TableColumn[] = [
  {
    field: 'groupName',
    title: TranslateRegistry.get.REPORT_GROUPS.TABLE.REPORT_GROUP_NAME,
    width: 494,
    sortable: true,
    cmp: ReportGroupNameColumnComponent
  },
  {
    field: 'status',
    title: TranslateRegistry.get.REPORT_GROUPS.TABLE.STATUS,
    width: 144,
    sortable: false,
    cmp: TextTranslateColumnComponent
  },
  {
    field: 'commodity',
    title: TranslateRegistry.get.REPORT_GROUPS.TABLE.COMMODITY,
    width: 112,
    sortable: false,
    icon: commodityTableIcon,
    cmp: IconColumnComponent
  },
  { field: 'applicable', title: TranslateRegistry.get.REPORT_GROUPS.TABLE.APPLICABLE, width: 304, sortable: false },
  {
    field: 'deviceCount',
    title: TranslateRegistry.get.REPORT_GROUPS.TABLE.DEVICES,
    width: 112,
    sortable: true,
    valueDelimiter: ','
  },
  { field: 'updatedOn', title: TranslateRegistry.get.REPORT_GROUPS.TABLE.LAST_EDITED, width: 158, sortable: true },
  { field: 'updatedBy', title: TranslateRegistry.get.REPORT_GROUPS.TABLE.UPDATED_BY, width: 176, sortable: true },
  {
    field: 'groupUID',
    title: TranslateRegistry.get.REPORT_GROUPS.TABLE.EDIT,
    sticky: true,
    width: 64,
    sortable: false,
    cmp: ReportGroupsEditModalColumnComponent
  }
];

export const reportGroupTableSortFiled: Record<string, EquipmentListingFieldName> = {
  groupName: ReportGroupsFieldName.GroupName,
  updatedOn: ReportGroupsFieldName.LastEdited,
  updatedBy: ReportGroupsFieldName.UpdatedBy,
  deviceCount: ReportGroupsFieldName.DeviceCount
};

export const udfSubcategory = 'UDF';
export const udfAttributeType = 'Udf';
